
export namespace PromiseUtils {
    class ApiException extends Error {
        message: string;
        status: number;
        response: string;
        headers: { [key: string]: any; };
        result: any;
    }


    const _cache = new Map<string, any>();





    export async function retry<T>(
        fn: () => Promise<T>,
        maxRetries: number = 3,
        timeoutMs: number = 1000
    ): Promise<T> {
        let retries = 0;
        let response = null;
        let error = null

        while (response == null && retries < maxRetries) {
            try {
                response = await fn();
            } catch (e) {
                error = e
            }
            if (response == null)
                await new Promise(_resolve => setTimeout(_resolve, timeoutMs));
            retries++;
        }
        if (response == null && error != null)
            throw new Error(error);
        return response;
    }
    export async function retryWeb<T>(
        fn: () => Promise<T>,
        maxRetries: number = 3,
        timeoutMs: number = 1000
    ): Promise<T> {
        let retries = 0;
        let response = null;
        let error = null

        while ((response == null || (response != null && typeof response === 'object' && 'status' in response && response?.status !== 200)) && retries < maxRetries) {
            try {
                response = await fn();
            } catch (e) {
                error = e
            }

            if ((response == null || (response != null && typeof response === 'object' && 'status' in response && response?.status !== 200)))
                await new Promise(_resolve => setTimeout(_resolve, timeoutMs));
            retries++;
        }
        if (response == null && error != null)
            throw new Error(error);

        return response;
    }


    export async function withLoader<T>(
        fn: () => Promise<T>,
        timeoutMs: number = 3000,
        onLoading: () => void = () => {},
        onCompletion: (result: T) => void = () => {}
    ): Promise<T> {
        let result: T;
        const _timeout = new Promise((_resolve, reject) => {
            setTimeout(() => {
                if (!result)
                    onLoading();
                reject(new Error("Promise timed out"));
            }, timeoutMs);
        });

        try {
            result = await Promise['any']([fn(), _timeout]) as T;
        } catch (error) {
            throw error;
        }

        onCompletion(result);
        return result;
    }

    export async function timeout<T>(
        fn: () => Promise<T>,
        timeoutMs: number = 3000,
    ): Promise<T> {
        return await Promise.race([
            fn(),
            new Promise<T>((resolve, reject) => setTimeout(() => reject({
                status: 408,
                error_message: 'Request Timeout'
            }), timeoutMs))
        ]);
    }

    export function debounce<T>(callback: (...args) => Promise<T>, delay: number = 300): (...args) => Promise<T> {
        let timer;

        return (...args) => {
            return new Promise((resolve, reject) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    try {
                        let output = callback(...args);
                        resolve(output);
                    } catch (err) {
                        reject(err);
                    }
                }, delay);
            })

        }
    }

    export async function cache<T>(
        fn: () => Promise<T>,
        key: string,
    ): Promise<T> {
        if (_cache.has(key))
            return new Promise(resolve => resolve(_cache.get(key)))
        return fn().then(_ => {
            _cache.set(key, _);
            return _;
        })
    }

    export async function allSynchronously<T>(
        resolvables: (() => Promise<T>)[]
    ): Promise<{ results: T[], errors: any[] }> {
        const results = [];
        const errors = [];
        for (const resolvable of resolvables) {
            const resp = await resolvable().catch(e => errors.push(e));
            results.push(resp)
        }
        return { results, errors };
    }

}
